import { Card, Typography, theme, Flex, Button } from "antd";
import { Trans, useTranslation } from "react-i18next";
import GetPaidImage from "assets/images/getpaid_banner.png";
import { useIntegrationMixpanelEvent } from "hooks/useMixpanel";

const GetPaidActivationModal = ({
  modal,
}: {
  modal: { destroy: () => void };
}) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  const { triggerMixpanelEvent } = useIntegrationMixpanelEvent();

  const handleActivateNow = () => {
    const customEvent = new CustomEvent("triggerGetPaidDrawer");
    document.dispatchEvent(customEvent);
    triggerMixpanelEvent("AR_Discovery_CTA");
    modal.destroy();
  };

  return (
    <Card
      cover={
        <img src={GetPaidImage} style={{ width: "100%", objectFit: "cover" }} />
      }
    >
      <Typography.Title
        level={4}
        style={{ textAlign: "center", marginBottom: token.marginLG }}
      >
        <Trans
          i18nKey="templates.integrations.getpaid_activation.modal.title"
          components={{
            green: <span style={{ color: token.colorSuccess }} />,
          }}
        />
      </Typography.Title>
      <Typography.Paragraph
        style={{ color: token.colorTextSecondary, textAlign: "center" }}
      >
        <Trans
          i18nKey="templates.integrations.getpaid_activation.modal.description"
          components={{ b: <b /> }}
        />
      </Typography.Paragraph>
      <Flex justify="center">
        <Button
          type="primary"
          style={{ marginTop: token.marginLG }}
          size="large"
          onClick={handleActivateNow}
        >
          {t("templates.integrations.getpaid_activation.modal.activate_now")}
        </Button>
      </Flex>
    </Card>
  );
};

export default GetPaidActivationModal;
